import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CreateAccountService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  createAccount(payload: any) {
    return this.http.post<any>(this.url('/account-adm-password'), payload);
  }

  getEnum() {
    const origin = this.authService.getOriginCurrency() || 'BRL';
    const params = new HttpParams().set('origin', origin);
    return this.http.get<any>(this.url('/enum'), { params });
  }
}